import { addMonths, isBefore } from '@e3dc-react/shell/Libs/date'
import { DeviceLinkModel } from '../models'
import { INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS } from '../constants'

/**  returns true if the device link has incomplete installation statement with deadline approaching */
export const checkIsDeadlineApproaching = (deviceLinks: DeviceLinkModel): boolean => {
  const now = new Date()
  const thresholdDate = addMonths(now, INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS)
  /* check if installation statement already submitted */
  if (deviceLinks.installationRequirements === true) return false

  if (!deviceLinks.ibnDeadlineAt) return false

  /* check if deadline approaching */
  const isDeadlineApproaching = isBefore(new Date(deviceLinks.ibnDeadlineAt), thresholdDate)

  return isDeadlineApproaching
}

/** sort devices in ascending order */
export const sortDevicesByDeadline = (deviceLinks: DeviceLinkModel[]): DeviceLinkModel[] => {
  return deviceLinks.sort((device1, device2) => {
    const date1 = new Date(device1.ibnDeadlineAt as string)
    const date2 = new Date(device2.ibnDeadlineAt as string)
    return isBefore(date1, date2) ? -1 : 1
  })
}
